import React, { useState } from 'react';

import GmpImage from 'assets/images/pages/menu/gmp.png';
import ImmigrantsImage from 'assets/images/pages/menu/immigrants.png';
import PharmacovigilanceImage from 'assets/images/pages/menu/pharmacovigilance.png';
import QualitymanagementImage from 'assets/images/pages/menu/quality-management.png';
import BatchManagementImage from 'assets/images/pages/menu/batch-management-menu.png';

import classes from './TopicsMenue.module.scss';


const TopicsMenu = () => {
    const [activeItem, setActiveItem] = useState(0);

    const MenuItems = [
        {
            title: 'Benefits Hub',
            image: GmpImage.src,
        },
        {
            title: 'GMP',
            image: GmpImage.src,
        },
        {
            title: 'Pharmacovigilance',
            image: PharmacovigilanceImage.src,
        },
        {
            title: 'Immigration',
            image: ImmigrantsImage.src,
        },
        {
            title: 'Quality Management',
            image: QualitymanagementImage.src,
        },
        {
            title: 'Batch Management',
            image: BatchManagementImage.src,
        }


    ];
    return (
        <div className={`${classes.wrapper} row`}>
            <div className="col-7">
                <div className={classes['item-wrapper']}>
                    <div className="row w-100">
                        <div className="col-5">
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(1)} href='https://pharmuni.com/benefits-hub/'>
                                    Benefits Hub
                                </a>
                            </div>
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(1)} href='https://pharmuni.com/gmp/'>
                                    GMP
                                </a>
                            </div>
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(2)} href='https://pharmuni.com/pharmacovigilance/'>
                                    Pharmacovigilance
                                </a>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(3)} href='https://pharmuni.com/immigration/'>
                                    Immigrants
                                </a>
                            </div>
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(4)} href='https://pharmuni.com/quality-management/'>
                                    Quality Management
                                </a>
                            </div>
                            <div className={classes['item']}>
                                <a onMouseEnter={() => setActiveItem(5)} href='https://pharmuni.com/batch-management/'>
                                    Batch Management
                                </a>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-5 d-flex flex-column justify-content-center align-items-center gap-2">
                <div className={classes['image']}>
                    <img src={MenuItems[activeItem].image} alt='topic_image' />
                </div>
            </div>
        </div>
    );
};

export default TopicsMenu;